import { render, staticRenderFns } from "./MedicineEdit.vue?vue&type=template&id=56f2c99a&scoped=true&"
import script from "./MedicineEdit.vue?vue&type=script&lang=js&"
export * from "./MedicineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2c99a",
  null
  
)

export default component.exports